// A part that can fail on its own (07, A tab that fails): what fails in it leaves it out, never the
// screen around it.
import { Component, type ReactNode } from 'react';

export class Quiet extends Component<{ children: ReactNode; fallback?: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? (this.props.fallback ?? null) : this.props.children;
  }
}
